export default "__VITE_ASSET__BKoXbVsr__"